/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationRes
 */
export interface NotificationRes {
    /**
     * 
     * @type {number}
     * @memberof NotificationRes
     */
    subscribers: number;
}

export function NotificationResFromJSON(json: any): NotificationRes {
    return NotificationResFromJSONTyped(json, false);
}

export function NotificationResFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationRes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subscribers': json['subscribers'],
    };
}

export function NotificationResToJSON(value?: NotificationRes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subscribers': value.subscribers,
    };
}


